export default __webpack_public_path__ + "b6c68d770e6fe04402b19f7896c7b9d8.png";